import {
  ApolloClient,
  InMemoryCache,
  NormalizedCacheObject,
  HttpLink,
  ApolloLink,
} from '@apollo/client';
import { onError } from 'apollo-link-error';
import Cookies from 'js-cookie';
import { MessageProps, useMessages } from '.';

const DOMAIN = '.alliesystems.com';
const CLIENT_COOKIE_NAME = '_al_client';
const DEV_DOMAINS = [
  'localhost',
  'dev.alliesystems.com',
  'allie-test-app.allie.local',
  'gcc-demo.allie.local',
];
const LOGIN_MUTATIONS = ['GuestLogin', 'EmailLogin', 'PinLogin', 'ResetPassword'];

interface useErrorLinkProps {
  errorMessagesByCode: Record<string, MessageProps>;
  errorMessagesByOperation: Record<string, MessageProps>;
  translations: Record<string, string>;
}

interface useClientProps extends useErrorLinkProps {
  uri: string;
  tryGuestLogin?: any;
}

const useErrorLink = ({
  errorMessagesByCode,
  errorMessagesByOperation,
  translations,
}: useErrorLinkProps) => {
  const { showMessage } = useMessages();

  const errorLink = onError(({ operation, graphQLErrors, networkError }) => {
    if (graphQLErrors) {
      graphQLErrors.forEach((error) => {
        console.error(`❌ [GraphQL error]: ${JSON.stringify(error.extensions?.code)}`);
      });
      console.log('graphQLErrors[0]?.extensions?.code', graphQLErrors[0]?.extensions?.code);
      if (graphQLErrors[0]?.extensions?.code) {
        const operationName = Object.keys(errorMessagesByOperation).find(
          (key) => key.toLowerCase() === operation.operationName.toLowerCase()
        );
        const errorMessage =
          errorMessagesByCode[graphQLErrors[0].extensions.code as string] ||
          (operationName ? errorMessagesByOperation[operationName] : undefined);

        errorMessage && (
        showMessage(
          errorMessage
            ? { ...errorMessage, title: translations[`${errorMessage.title}`] }
            : {
                ...errorMessagesByCode.UNKNOWN_ERROR,
                title: translations[`${errorMessagesByCode.UNKNOWN_ERROR.title}`],
              }
        ));
      } else {
        // showMessage({
        //   ...errorMessagesByCode.UNKNOWN_ERROR,
        //   title: translations[`${errorMessagesByCode.UNKNOWN_ERROR.title}`],
        // });
      }
    } else {
      if (networkError) {
        if (!networkError.message.includes('The user aborted a request')) {
          console.error(`❌ [Network error]: ${JSON.stringify(networkError)}`);
      //     showMessage({
      //       ...errorMessagesByCode.NETWORK_ERROR,
      //       title: translations[`${errorMessagesByCode.NETWORK_ERROR.title}`],
      //     });
        }
      } else {
        console.error(`❌ [Unknown error]: for operation: ${operation.operationName}`);
      //   showMessage({
      //     ...errorMessagesByCode.UNKNOWN_ERROR,
      //     title: translations[`${errorMessagesByCode.UNKNOWN_ERROR.title}`],
      //   });
      }
    }
  });

  return { errorLink };
};

export const useClient = ({
  uri,
  errorMessagesByCode,
  errorMessagesByOperation,
  translations,
  tryGuestLogin,
}: useClientProps) => {
  const { errorLink } = useErrorLink({
    errorMessagesByCode,
    errorMessagesByOperation,
    translations,
  });

  const httpLink = new HttpLink({
    uri,
    credentials: 'include',
  });

  const preLink = new ApolloLink((operation, forward) => {
    if (document.hidden && operation.operationName !== 'GenerateToken') {
      const controller = new AbortController();
      operation.setContext({
        ...operation.getContext(),
        controller,
        fetchOptions: {
          signal: controller.signal,
        },
      });

      controller.abort();      
    } else {
      if (
        !LOGIN_MUTATIONS.includes(operation.operationName) &&
        !DEV_DOMAINS.includes(window.location.hostname) &&
        Cookies?.get(CLIENT_COOKIE_NAME) !== window.location.hostname.replace(DOMAIN, '')
      ) {
        return tryGuestLogin?.();
      }
    }

    return forward(operation);
  });

  const client: ApolloClient<NormalizedCacheObject> = new ApolloClient({
    cache: new InMemoryCache(),
    queryDeduplication: false,
    link: preLink.concat(errorLink as any).concat(httpLink as any) as any,
  });

  return { client };
};
